import { FlexBox } from 'src/ui/common/atoms/flex-box';
import styled from 'styled-components';

export const StyledThreeDots = styled(FlexBox)`
    cursor: pointer;
    height: 40px;
    width: 40px;
    flex: 0 0 40px;
    background: ${({ theme }) => theme.colors.black};
    margin-left: 5px;
    user-select: none;

    &:hover {
        background: ${({ theme }) => theme.colors.gs400};
    }
`;
